
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'; // Make sure this CSS is imported

const ScoreCard = ({
  title,
  subtitle = "",
  value,
  valueCompare = "",
  textColor = "",
  redirectPath,
  dataLoading
}) => {
  const navigate = useNavigate();


  const handleClick = () => {
    if (redirectPath) {
      navigate(redirectPath);
    }
  };

  const isClickable = !!redirectPath;

  

  return (
    <div
      className={`dashboard__card score-card ${isClickable ? 'clickable' : ''}`}
      onClick={isClickable ? handleClick : undefined}
      style={isClickable ? { cursor: 'pointer' } : {}}
    >
      <div className="dashboard__card__title">{title}</div>

      <div className="score-card__values " style={{ minHeight: '2.5rem' }}>
        {dataLoading ? (
          <>
            <Skeleton width={60} height={40} style={{marginBottom:"4px"}} />
          </>
        ) : (
          <>
            <span className={`score-card__value ${textColor}`}>{value}</span>
            {valueCompare !== "" && (
              <span className={`score-card__value_compare ${textColor}`}>/ {valueCompare}</span>
            )}
          </>
        )}
      </div>

      {subtitle && <p className="dashboard__card__subtitle">{subtitle}</p>}
    </div>
  );
};

export default ScoreCard;
